import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { connect } from 'react-redux';
import { setField } from "../../../../store/Actions/Actions";
import { getApplication } from "../../../../store/Selectors";
import SelectComponentV2 from "../SelectComponentV2";
var SelectComponent = function SelectComponent(props) {
  var items = props.items,
    placeholder = props.placeholder,
    errorMessage = props.errorMessage,
    clearError = props.clearError,
    keyName = props.keyName,
    field = props.field;
  var handleChange = function handleChange(event) {
    props.setField({
      key: keyName,
      value: event.target.value
    });
    clearError(keyName);
  };
  var options = React.useMemo(function () {
    if (items === undefined || items === null) {
      return [];
    }
    return items.map(function (item) {
      return {
        label: item.name,
        value: item.id
      };
    });
  }, [items]);
  return /*#__PURE__*/React.createElement(SelectComponentV2, {
    error: errorMessage,
    extraLabelsForTests: true,
    id: keyName,
    label: placeholder,
    options: options,
    onChange: handleChange,
    value: field
  });
};
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var application = getApplication(state);
  return {
    field: application[ownProps.keyName]
  };
};
var connector = connect(mapStateToProps, {
  setField: setField
});
export default connector(SelectComponent);